import { render, staticRenderFns } from "./WAIOTVJG.vue?vue&type=template&id=2a55c84e&scoped=true"
import script from "./WAIOTVJG.vue?vue&type=script&lang=js"
export * from "./WAIOTVJG.vue?vue&type=script&lang=js"
import style0 from "./WAIOTVJG.vue?vue&type=style&index=0&id=2a55c84e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55c84e",
  null
  
)

export default component.exports